export enum ParticipantRoles {
    DATASPACE_OWNER = 'DATASPACE_OWNER',
    DATASPACE_OPERATOR = 'DATASPACE_OPERATOR',
    APPLICATION_PROVIDER = 'APPLICATION_PROVIDER',
    DATASPACE_PARTICIPANT = 'DATASPACE_PARTICIPANT'
}